import { gql } from "@apollo/client";
import {
    organizationDetailsFragment,
    organizationPermissionsFragment,
    organizationAuthorizedOperationsFragment,
} from "../fragments";

export const getSelectedOrganization = gql`
    query organization($ghostMode: Boolean = false) {
        selectedOrganization @client {
            ...OrganizationDetails
            ...OrganizationPermissions
            ...OrganizationAuthorizedOperations @skip(if: $ghostMode)
            appsManagementEnabled
            accountIds
        }
    }
    ${organizationDetailsFragment}
    ${organizationPermissionsFragment}
    ${organizationAuthorizedOperationsFragment}
`;
